import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Box, BoxProps } from '~Styles';
import { FieldError } from '~Styles/forms';

interface FieldProps extends BoxProps {
  children: React.ReactNode;
  name?: string;
  label?: string;
}

export default function Field({ children, name, label, ...rest }: FieldProps) {
  const {
    formState: { errors },
  } = useFormContext();

  // Not passing a name for the field will cause it to render a "dummy field"
  if (!name) {
    return <Box>{children}</Box>;
  }
  return (
    <Box {...rest}>
      {label && <label>{label}</label>}
      {children}
      <FieldError>{!!errors && errors[name]?.message}</FieldError>
    </Box>
  );
}
